import React, { useEffect, useState } from "react";
import axios from "axios";
import { Award, Sparkles, Loader2 } from "lucide-react";
import { API, useApp } from "@/state/AppContext";

export default function LoyaltyCard() {
  const { user, authHeaders } = useApp();
  const [state, setState] = useState(null);
  const [loading, setLoading] = useState(true);

  const paidUser = user && (user.subscription === "plus" || user.subscription === "premium");

  useEffect(() => {
    if (!paidUser) { setLoading(false); return; }
    axios.get(`${API}/payments/loyalty-status`, { headers: authHeaders })
      .then(r => setState(r.data))
      .catch(() => setState(null))
      .finally(() => setLoading(false));
  }, [paidUser, authHeaders]);

  if (!paidUser || loading || !state) return null;

  const applied = state.applied;
  const pct = state.months_required
    ? Math.min(100, ((state.months_active || 0) / state.months_required) * 100)
    : 0;

  return (
    <div
      data-testid="loyalty-card"
      className={`rounded-3xl p-4 border ${applied
        ? "bg-gradient-to-br from-amber-50 via-white to-amber-50 border-amber-200"
        : "bg-white border-slate-200"}`}
    >
      <div className="flex items-center gap-2">
        {applied ? <Sparkles className="w-5 h-5 text-amber-500" />
                 : <Award className="w-5 h-5 text-blue-600" />}
        <div className="text-xs uppercase tracking-wider font-semibold text-slate-500">
          Treuerabatt
        </div>
      </div>

      {applied ? (
        <>
          <h3 className="mt-1 text-lg font-bold text-amber-900" data-testid="loyalty-applied-title">
            10 % dauerhaft aktiv
          </h3>
          <p className="mt-1 text-sm text-slate-700">
            Danke, dass du bei BriefAssist bist. Der Rabatt wird auf alle zukünftigen Rechnungen angewendet.
          </p>
        </>
      ) : (
        <>
          <h3 className="mt-1 text-lg font-bold text-slate-900">
            Bald: 10 % lebenslang
          </h3>
          <p className="mt-1 text-sm text-slate-600">
            Als Dankeschön bekommst du nach {state.months_required} Monaten Abo einen dauerhaften Rabatt.
          </p>
          <div className="mt-3">
            <div className="h-2 rounded-full bg-slate-100 overflow-hidden">
              <div className="h-full bg-blue-600 transition-all" style={{ width: `${pct}%` }} />
            </div>
            <div className="mt-1.5 text-xs text-slate-500" data-testid="loyalty-progress">
              {state.months_active?.toFixed?.(1) ?? state.months_active} / {state.months_required} Monate
            </div>
          </div>
        </>
      )}
    </div>
  );
}
